<template>
  <div class="category-wrapper">
    <div
      class="category-item cursor-pointer"
      :class="{ 'category-item-selected': categoryState === null }"
      @click="setCategory(null)"
    >
      <span
        class="material-icons-outlined category-item-icon"
        :class="{
          'category-item-icon-block': categoryState === null,
        }"
        >done</span
      >
      {{ $t("3916") }}
    </div>
    <div
      v-for="(category, i) in categoryList"
      class="category-item cursor-pointer"
      :class="{
        'category-item-selected':
          categoryState && categoryState.value === category.value,
      }"
      :key="i"
      @click="setCategory(category)"
    >
      <span
        class="material-icons-outlined category-item-icon"
        :class="{
          'category-item-icon-block':
            categoryState && categoryState.value === category.value,
        }"
        >done</span
      >
      {{ category.text }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import learnApi from "@/api/learnApi";

export default {
  name: "CategoryList",
  data() {
    return {
      categoryList: null,
    };
  },
  computed: {
    ...mapState({
      categoryState: (state) => state.learn.categoryState,
    }),
  },
  mounted() {
    this.getCategoryList();
  },
  methods: {
    ...mapActions("learn", ["SET_CATEGORY_STATE"]),
    async getCategoryList() {
      try {
        const result = await learnApi.fetchCategoryList();
        this.categoryList = result.data.data;
      } catch (error) {
        console.log("GET CATEGORY ERROR : ", error);
      }
    },

    setCategory(value) {
      this.SET_CATEGORY_STATE(value);
    },
  },
};
</script>

<style scoped>
.category-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0 8px 0;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.category-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
.category-item {
  border: 1px solid var(--Iconinactive);
  border-radius: 15px;
  color: var(--Iconinactive);
  padding: 5px 10px;
  font-size: 13px;
  margin-right: 8px;
  margin-bottom: 8px;
  height: 30px;
  text-align: center;
  white-space: nowrap;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.category-item.category-item-selected {
  border: 1px solid var(--ContentsRed);
  color: var(--ContentsRed);
  background-color: rgba(241, 109, 112, 0.3);
}
.category-item-icon {
  display: none;
  font-size: 16px;
  margin-right: 3px;
}
.category-item-icon-block {
  display: block;
}
</style>